import { FC } from 'react';
import { Input } from "@/components/ui/input";
import { FormLabel } from "@/components/ui/form";
import { Card, CardContent } from "@/components/ui/card";
import { QuizQuestion } from './types';

interface QuizQuestionFormProps {
  question: QuizQuestion;
  questionNumber: number;
  onUpdate: (updatedQuestion: QuizQuestion) => void;
}

export const QuizQuestionForm: FC<QuizQuestionFormProps> = ({
  question,
  questionNumber,
  onUpdate,
}) => {
  const handleQuestionChange = (value: string) => {
    onUpdate({
      ...question,
      question: value
    });
  };

  const handleCorrectAnswerChange = (value: string) => {
    onUpdate({
      ...question,
      correct_answer: value
    });
  };

  const handleWrongAnswerChange = (value: string, answerIndex: number) => {
    const newWrongAnswers = [...question.wrong_answers];
    newWrongAnswers[answerIndex] = value;
    onUpdate({
      ...question,
      wrong_answers: newWrongAnswers
    });
  };

  return (
    <Card className="relative">
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="grid gap-4">
            <div>
              <FormLabel className="flex items-center gap-2 mb-2">
                <span className="font-semibold text-lg">Pregunta {questionNumber}</span>
                {!question.question?.trim() && (
                  <span className="text-xs text-red-500">*Requerido</span>
                )}
              </FormLabel>
              <Input
                value={question.question}
                onChange={(e) => handleQuestionChange(e.target.value)}
                placeholder="Escribe la pregunta"
                className={!question.question?.trim() ? 'border-red-500' : ''}
              />
            </div>
            
            <div>
              <FormLabel className="flex items-center gap-2 mb-2">
                <span className="font-medium">Respuesta Correcta</span>
                {!question.correct_answer?.trim() && (
                  <span className="text-xs text-red-500">*Requerido</span>
                )}
              </FormLabel>
              <Input
                value={question.correct_answer}
                onChange={(e) => handleCorrectAnswerChange(e.target.value)}
                placeholder="Escribe la respuesta correcta"
                className={!question.correct_answer?.trim() ? 'border-red-500' : ''}
              />
            </div>

            <div>
              <FormLabel className="flex items-center gap-2 mb-2">
                <span className="font-medium">Respuestas Incorrectas</span>
              </FormLabel>
              <div className="space-y-3">
                {question.wrong_answers.map((answer, aIndex) => (
                  <div key={aIndex}>
                    <Input
                      value={answer}
                      onChange={(e) => handleWrongAnswerChange(e.target.value, aIndex)}
                      placeholder={`Respuesta incorrecta ${aIndex + 1}`}
                      className={!answer?.trim() ? 'border-red-500' : ''}
                    />
                    {!answer?.trim() && (
                      <span className="text-xs text-red-500 mt-1">*Requerido</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};